import Toman from "../../Utilities/Toman";
import Modal from "../../Utilities/Modal";
import {useState} from "react";
import ApiRoute from "../../../helper/api";
import {formatNumberWithDots, getDateAsReadableFormat} from "../../../helper/general";
import ProductSelect from "../../Product/ProductSelect";
import CouponSelect from "../CouponSelect";
import { Link } from "react-router-dom";
import CategorySelect2 from "../../Product/Category/CategorySelect2";
import BrandSelect2 from "../../Product/Category/BrandSelect2";
import { toast } from "react-toastify";

export default function RemoveRegularPriceFromProducts({closeModal}){
    const [category , setCategory] = useState(null)
    const [brand , setBrand] = useState(null)

    async function handleSubmit(){
        const categorySlugs = Array.isArray(category) ? category.map(item => item.slug) : [];
        const brandValues = Array.isArray(brand) ? brand.map(item => item.value) : [];
        const res = await ApiRoute.product.removeRegularPrice.fn({
            category_slugs: categorySlugs,
            brand_values: brandValues,
        })
        if (res?.status_code === 200){
            const count = res?.results?.count || 0;
            toast.info(`${count} محصول قیمت ویژه عادی‌شان حذف شد`);
            //closeModal();
        }else{
            toast.error('خطا در حذف قیمت ویژه عادی');
        }
        //setCategory(null);
        //setBrand(null);
    }

    return (
        <Modal isOpen={true} onClose={closeModal}>
            <div className="page-title mb-3"><span className="inline-block bg-white text-xs text-purple-1 pl-3">حذف قیمت ویژه عادی از محصولات</span>
            </div>

            <div className="form grid-form grid grid-cols-1 text-xs gap-3 my-6">

            <div>
                            <label>
                                <span className="block">دسته بندی</span>
                                <CategorySelect2
                                    defaultValue={[]}
                                    assignItem={(s) => {
                                        setCategory(s)
                                    }}
                                    placeholder="انتخاب دسته"
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">برند</span>
                                <BrandSelect2
                                    defaultValue={[]}
                                    assignItem={(s) => {
                                        setBrand(s)
                                    }}
                                    placeholder="انتخاب برند"
                                />
                            </label>
                        </div>

            </div>


            <div className="flex justify-end mt-4">
                <button onClick={handleSubmit} className="btn-purple px-5 py-2">اعمال</button>
            </div>

        </Modal>
    )
}